import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { isNotEmpty } from "@/libs/tools";
import { LikeOrNot } from "../LikeOrNot/index";
import { AiAvatar } from "../AiAvatar";
import { LeftText } from "../LeftText";

@Component({
    name: "ChoiceText",
    components: {
        LikeOrNot,
        AiAvatar,
        LeftText
    }
})
export default class ChoiceText extends Vue {
    @Prop() readonly text: string;
    @Prop() readonly teacherAvatar: string;
    @Prop() readonly choiceContent: string;
    @Prop() readonly choiceOptions: string;
    @Prop() readonly userAnswer: string;
    @Prop() readonly item: any;
    @Prop() studentAvatar: string;
    private hasSelect: boolean = false;
    private activeClass: number = -1;
    mounted() {
        this.studentAvatar = this.studentAvatar
            ? this.studentAvatar
            : "https://asset.greedyai.com/sun/img/defaultAvatar.png";
        if (isNotEmpty(this.userAnswer)) {
            this.hasSelect = true;
            //@ts-ignore
            this.activeClass = this.userAnswer.charCodeAt() - 65;
        }
    }

    // @Emit()
    handleSelect(key) {
        if (this.hasSelect) {
            return false;
        } else {
            this.hasSelect = true;
            this.activeClass = key;
            key = String.fromCharCode(key + 65);
            //@ts-ignore
            this.$emit("select", { key: key, pageId: this.pageId });
        }
    }
}

//@ts-ignore
export { default as ChoiceText } from "./index.vue";
